const metaConfig = {
  "/": {
    title: "Home | Revenue Department Government Of Maharashtra",
    description:
      "Welcome to the home page of Revenue Department Government Of Maharashtra.",
    keywords: "home, revenue Department Government Of Maharashtra",
  },
  "/history": {
    title: "About Us | Revenue Department Government Of Maharashtra",
    description:
      "Learn more about us at Revenue Department Government Of Maharashtra.",
    keywords: "about us, revenue Department Government Of Maharashtra",
  },
  "/user_citizen_charter": {
    title: "Citizen Charter | Revenue Department Government Of Maharashtra",
    description: "Citizen Charter",
    keywords: "citizen charter, revenue Department Government Of Maharashtra",
  },
  "/contact": {
    title: "Contact | Revenue Department Government Of Maharashtra",
    description:
      "Get in touch with us at Revenue Department Government Of Maharashtra.",
    keywords:
      "contact, revenue Department Government Of Maharashtra, support, help section",
  },
  "/screen_reader": {
    title:
      "Screen Reader Access | Revenue Department Government Of Maharashtra",
    description: "Information about description screen reader access",
    keywords:
      "screen reader access, revenue Department Government Of Maharashtra, accessiblity",
  },
  "/photo_gallery": {
    title: "Gallery | Revenue Department Government Of Maharashtra",
    description: "Photo Gallery",
    keywords: "gallery, revenue Department Government Of Maharashtra",
  },
  "/subjects": {
    title: "Subjects | Revenue Department Government Of Maharashtra",
    description: "Subjects Information",
    keywords: "subjects, revenue Department Government Of Maharashtra",
  },
  "/right_to_service": {
    title: "RTS List | Revenue Department Government Of Maharashtra",
    description: "Right to Service List and Apply for Notified Services",
    keywords:
      "e-citizens, rts list, notified service, revenue Department Government Of Maharashtra",
  },
  "/programs&schemes": {
    title: "Program & Schemes | Revenue Department Government Of Maharashtra",
    description: "Program and Schemes",
    keywords:
      "program and schemes, revenue Department Government Of Maharashtra",
  },
  "/policies": {
    title: "Website Policies | Revenue Department Government Of Maharashtra",
    description: "Website Policies",
    keywords:
      "website policies, policy, hyperlinking, copyright, privacy, revenue Department Government Of Maharashtra",
  },
  "/terms_of_use": {
    title: "Terms of Use | Revenue Department Government Of Maharashtra",
    description: "Terms of Use",
    keywords:
      "terms of use, disclaimer, revenue Department Government Of Maharashtra",
  },
  "/feedback": {
    title: "Feedback | Revenue Department Government Of Maharashtra",
    description: "Information about description feedback",
    keywords:
      "feedback, help, support, revenue Department Government Of Maharashtra",
  },
  "/contact_us": {
    title: "Contact | Revenue Department Government Of Maharashtra",
    description: "Contact Us",
    keywords:
      "contact us, support, help, revenue Department Government Of Maharashtra",
  },
  "/about_this_website": {
    title: "About this website | Revenue Department Government Of Maharashtra",
    description: "About this website",
    keywords:
      "about this website, about, revenue Department Government Of Maharashtra",
  },
  "/help": {
    title: "Help | Revenue Department Government Of Maharashtra",
    description: "Help",
    keywords:
      "help, support, accessibility, screen reader, revenue Department Government Of Maharashtra",
  },
  "/web_info_manager": {
    title:
      "Web Information Manager | Revenue Department Government Of Maharashtra",
    description: "web information manager",
    keywords:
      "web information manager, contact,  revenue Department Government Of Maharashtra",
  },
  "/sitemap": {
    title: "Sitemap | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "sitemap, accessibility, revenue Department Government Of Maharashtra",
  },
  "/showECitizen/acts_rules": {
    title: "Acts & Rules | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, acts and rules, revenue Department Government Of Maharashtra",
  },
  "/showECitizen/important_government_rules": {
    title:
      "Important Government Resolutions | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, important government resolutions , revenue Department Government Of Maharashtra",
  },
  "/showECitizen/user_manual": {
    title: "User Manual | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, user manual , revenue Department Government Of Maharashtra",
  },
  "/showECitizen/right_to_information": {
    title:
      "Right to Information | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, rti , right to information , revenue Department Government Of Maharashtra",
  },
  "/showECitizen/application_forms": {
    title: "Application Forms | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, application forms, revenue Department Government Of Maharashtra",
  },
  "/showECitizen/minutes_meeting": {
    title: "Minutes of Meeting | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, minutes of meeting, revenue Department Government Of Maharashtra",
  },
  "/showECitizen/notifications": {
    title: "Notifications | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, notifications , revenue Department Government Of Maharashtra",
  },
  "/showECitizen/grievance_redressal": {
    title: "Grievance Redressal | Revenue Department Government Of Maharashtra",
    description: "Information about website's sitemap",
    keywords:
      "e-citizens, grievance redressal , revenue Department Government Of Maharashtra",
  },
  "/showECitizen/100_days_program": {
    title: "100 Days Program | Revenue Department Government Of Maharashtra",
    description: "Information about revenue departments 100 days program",
    keywords:
      "e-citizens, 100 Days Program , revenue Department Government Of Maharashtra",
  },
  "/dashboard": {
    title: "Dashboard | Revenue Department Government Of Maharashtra",
    description:
      "Numerical and graphical information about revenue departments",
    keywords: "dashbaord , revenue Department Government Of Maharashtra",
  },
  "/accessibility_statement": {
    title:
      "Accessibility Statement | Revenue Department Government Of Maharashtra",
    description:
      "We are committed to making our website accessible to as many people as possible, regardless of technology or ability. This page summarizes the key features we've implemented to support an inclusive experience.",
    keywords: "Accessibility Features , Accessibility",
  },
  "/aaple_sarkar": {
    title: "Aaple Sarkar | Revenue Department Government Of Maharashtra",
    description:
      "Aaple Sarkar is the official online portal of the Maharashtra government (India) for citizens to access over 400 government services, like applying for certificates (caste, land records), licenses, and welfare schemes, all from one platform, offering transparency, time-bound delivery, and an online appeal system under the Right to Public Services Act.",
    keywords:
      "Aaple Sarkar , Maharashtra Right to Public Services Act , Government of Maharashtra",
  },
};

export default metaConfig;
